<template>
  <div id="app">
    <!-- <img src="./assets/logo.png"> -->
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App',
  data() {
    return {

    }
  },
  created() {
      var that =this;
      //that.getToken();
      that.timer = setInterval(function () {
         // that.getToken();
      },108000)
  },
  methods: {
    // 获取token，报警历史用
    
    getToken(){ 
       let that = this;
        var urlprefix = that.GLOBAL.farmapiurl;
      
        that.$axios({
            method: 'post',
            url: urlprefix+'api/farmerApi2/login',
            data: {
                username: 'yy-admin',
                password: '123456'
            }
        })
        .then(function (response) {
            console.log(response.data);
            var r_data = response.data;
            if(r_data.success){
                //token 保存
                localStorage.setItem('token', r_data.content.token);
             //   that.getLandList();
                console.log('存储的token', localStorage.getItem('token'))
            }else{
                console.log('登录失败')
                localStorage.setItem('token', '');
            }
        })
        .catch(function (error) {
            console.log(error);
        });
    },
    getLandList(){
      var that = this;
      var token =  window.localStorage.getItem("token");
        var urlprefix = that.GLOBAL.farmapiurl;
      that.$axios({
          method: 'get',
          url: urlprefix+'api/landApi/viewPlantFarmId/' + this.GLOBAL.farmId,
          headers: {
              Authorization: token
          },
      }).then(res => {
          var r_data = res.data;
          that.GLOBAL.landList = [];
          that.GLOBAL.landSnList = [];
          if(r_data.success){
              that.GLOBAL.landList = r_data.content.farmLands;
              that.GLOBAL.landSnList = r_data.content.farmLands.map(v => v.landSn);
          }
          console.log('园区下的地块列表', that.GLOBAL.landList)
          console.log('园区下的地块sn列表', that.GLOBAL.landSnList)
      })
    },
  }
}

</script>

<style>
#app {
  /* font-family: 'Avenir', Helvetica, Arial, sans-serif; */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /* text-align: center; */
  color: #fff;
  /* margin-top: 60px; */
}
</style>



// WEBPACK FOOTER //
// src/App.vue